var apiUrl =
  process.env.VUE_APP_COMMON_API_URL ||
  process.env.VUE_APP_API_BASE_URL ||
  "http://127.0.0.1:48080"
export default apiUrl
